<template>
  <div v-if="!loading" class="container_padding">
    <div class="test_wall">
      <div class="result_title">{{$t('message.exam_result')}}</div>
      <div class="result_score">
        <img src="../../../assets/web/Grade.png" />
        <div class="result_totalScore">{{result && result.totalScore}}</div>
        <div class="result_scoreLevel">{{passOrNot}}</div>
        <div class="result_tips">{{$t('message.write_tips')}}</div>
      </div>
      <div class="result_test_situation">
        <div class="situation_title">{{$t('message.answers_situation')}}</div>
        <div class="situation_items">
          <div
            :class="'situation_item ' + (item.correct ? '':'situation_item_red')"
            v-for="(item,index) in result.questionAnswers"
            :key="item.id"
            @click="showQuestion(item)"
          >{{index +1}}</div>
        </div>
      </div>
      <div class="row foot_btn">
        <mBtn
          :loading="testLoading"
          @click="$router.push('/learning/record')"
        >{{$t('message.return_exam_record')}}</mBtn>
        <mBtn :loading="testLoading" @click="reTest">{{$t('message.reTest')}}</mBtn>
        <mBtn @click="$router.push('/')" class="custom-btn">{{$t('message.back_to_home')}}</mBtn>
      </div>

      <Questionnaire></Questionnaire>
    </div>
    <!-- 問卷彈窗 -->
    <QuestionTipsDialog :courseTitle="result && result.course" :show="showQuestionTips" :id="questionnaire.length > 0 && questionnaire[0].id" @close="showQuestionTips = false" @handleContinue="showQuestionTips = false" showBack></QuestionTipsDialog>
  </div>
</template>

<script>
import UserAssessmentsAPI from "../../../api/UserAssessmentsAPI";
import mBtn from "../../../components/mBtn";
import CourseAPI from "../../../api/CourseAPI";
import Questionnaire from "../../../components/Questionnaire";
import QuestionTipsDialog from "../../../components/QuestionTipsDialog";
export default {
  components: { mBtn, Questionnaire, QuestionTipsDialog },
  data() {
    return {
      loading: false,
      result: null,
      testLoading: false,
      showQuestionTips: false,
      questionnaire: [],
    };
  },
  computed: {
    passOrNot() {
      const totalScore = parseInt(this.result.totalScore);
      if (totalScore) {
        return totalScore >= 90
          ? this.$t("message.exam_excellent")
          : totalScore >= 60
          ? this.$t("message.exam_pass")
          : totalScore < 60
          ? this.$t("message.exam_fail")
          : "";
      } else {
        return "";
      }
      return result.totalScore;
    }
  },
  methods: {
    // 重新考試
    reTest() {
      const courseId = sessionStorage.getItem("courseId");
      const lang = this.$i18n.locale;
      this.testLoading = true;
      CourseAPI.getOne(courseId, lang)
        .then(res => {
          // 課程不足80%提示
          if (res.progress <= 0.8) {
            this.testLoading = false;
            this.$alert(this.$t("message.test_tips"), this.$t("message.tips"), {
              confirmButtonText: this.$t("message.confirm"),
              callback: action => {
                console.log(action);
              }
            });
          } else {
            UserAssessmentsAPI.assessment(courseId, lang)
              .then(res => {
                this.testLoading = false;
                sessionStorage.setItem("testing", true);
                sessionStorage.setItem("questionCount", res.questionCount);
                sessionStorage.setItem("questionNum", 0);
                this.$router.push({
                  path: "/learning/test"
                });
                console.log(res);
              })
              .catch(err => {
                this.testLoading = false;
                this.$error(err);
                console.log(err);
              });
          }
        })
        .catch(err => {
          this.testLoading = false;
          this.$error(err);
          console.log(err);
        });
    },
    showQuestion(val) {
      sessionStorage.setItem("questionNum", "");
      sessionStorage.setItem("questionCount", "");
      sessionStorage.setItem("testing", false);
      this.$router.push({
        name: "test",
        params: {
          question: val
        }
      });
    },
    get(){
      const courseVersionId = this.$route.query.resultCourseId;
      const id = this.$route.query.resultId;
      this.loading = true;
      UserAssessmentsAPI.findByCourseAndUser(courseVersionId, id, this.$i18n.locale)
      .then(res => {
        this.result = res;
      })
      .catch(err => this.$error(err))
      .finally(() => this.loading = false)
    },
    // 獲取問卷數據
    getQuestionnaire(){
      const courseId = sessionStorage.getItem("courseId") || null;
      const locale = this.$i18n.locale;
      if(courseId){
        CourseAPI.listQuestionnaireByCourse(courseId, locale)
          .then(res => {
            this.loading = false;
            this.questionnaire = res;
            if(res.length > 0 && !res[0].participated){
              this.showQuestionTips = true;
            }
          })
          .catch(err => {
            this.loading = false;
            this.$error(err);
          });
      }
    }
  },
  created() {
    if(this.$route.query.resultCourseId && this.$route.query.resultId){
      this.get();
      if(this.$route.query.submit){
        this.getQuestionnaire();
      }
    }else{
      this.$router.push("/index");
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.result_tips {
  font-size: 16px;
  font-weight: 500;
  color: #68d0bc;
  margin: 12px 0;
}
</style>